"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chart = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var utils_1 = require("../../../utils");
var Chart_styled_1 = require("./Chart.styled");
var ChartGrid_1 = require("./ChartGrid/ChartGrid");
var ChartLegend_1 = require("./ChartLegend/ChartLegend");
var ChartSet_1 = require("./ChartSet/ChartSet");
var utils_2 = require("./utils");
var Shadow = (0, react_1.forwardRef)(function (_a, ref) {
    var side = _a.side, rest = __rest(_a, ["side"]);
    var Icon = (0, core_1.useComponents)().Icon;
    return (react_1.default.createElement(Chart_styled_1.StyledShadow, __assign({ side: side }, rest, { ref: ref, "data-testid": "chart-shadow" }),
        react_1.default.createElement(Icon, { name: side === 'left' ? 'chevron-left' : 'chevron-right' })));
});
var subPixelCorretion = 1;
var Chart = function (_a) {
    var _b, _c;
    var data = _a.data, formatter = _a.formatter, legend = _a.legend, barWidth = _a.barWidth, rest = __rest(_a, ["data", "formatter", "legend", "barWidth"]);
    var TextLink = (0, core_1.useComponents)().TextLink;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _d = __read((0, react_1.useState)(false), 2), shouldScroll = _d[0], setShouldScroll = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), leftShadow = _e[0], setLeftShadow = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), rightShadow = _f[0], setRightShadow = _f[1];
    var width = (0, utils_1.useWindowDimensions)().width;
    var scrollRef = (0, react_1.createRef)();
    var grid = (0, utils_2.generateGrid)((0, utils_2.getChartMax)(data));
    var scale = (0, utils_2.getScaleFromGrid)(grid);
    var itemLabels = data.map(function (set) { return set.label; });
    (0, react_1.useEffect)(function () {
        if (scrollRef.current &&
            scrollRef.current.scrollWidth >
                scrollRef.current.clientWidth + subPixelCorretion) {
            setShouldScroll(true);
            setRightShadow(true);
        }
        else {
            setShouldScroll(false);
            setRightShadow(false);
        }
        // Runs on first render and when the data or screen width changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, width]);
    var onScroll = function (_a) {
        var target = _a.target;
        var _b = target, scrollWidth = _b.scrollWidth, clientWidth = _b.clientWidth, scrollLeft = _b.scrollLeft;
        var edgeBuffer = 5;
        if (scrollLeft > edgeBuffer && !leftShadow) {
            setLeftShadow(true);
        }
        else if (scrollLeft === 0 && leftShadow) {
            setLeftShadow(false);
        }
        var max = scrollWidth - (clientWidth + edgeBuffer);
        if (scrollLeft >= max && rightShadow) {
            setRightShadow(false);
        }
        else if (scrollLeft < max && !rightShadow) {
            setRightShadow(true);
        }
    };
    return (react_1.default.createElement("div", __assign({}, rest),
        react_1.default.createElement(ChartLegend_1.ChartLegend, { legend: legend }),
        react_1.default.createElement(ChartGrid_1.ChartGrid, { grid: grid, formatter: formatter, itemLabels: itemLabels, barWidth: barWidth },
            react_1.default.createElement(Chart_styled_1.StyledChartSkipLink, { id: "chart-start", as: TextLink, href: "#chart-end" },
                react_1.default.createElement(Copy, { copyKey: "skipChart" })),
            react_1.default.createElement(Chart_styled_1.StyledChartWrapper, { role: "list", onScroll: onScroll, ref: scrollRef, shouldScroll: shouldScroll },
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CHART_SHADOW, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
                    react_1.default.createElement(Shadow, { side: "left", visible: leftShadow, onClick: function () {
                            if (scrollRef.current) {
                                var _a = scrollRef.current, clientWidth = _a.clientWidth, scrollLeft = _a.scrollLeft;
                                scrollRef.current.scrollLeft = scrollLeft - clientWidth;
                            }
                        } })),
                data.map(function (set, index) { return (react_1.default.createElement(ChartSet_1.ChartSet, { barWidth: barWidth, set: set, legend: legend, key: "set-".concat(index), scale: scale, scrollRef: scrollRef, "data-testid": "chart-set" })); }),
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CHART_SHADOW, properties: (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
                    react_1.default.createElement(Shadow, { side: "right", visible: rightShadow, onClick: function () {
                            if (scrollRef.current) {
                                var _a = scrollRef.current, clientWidth = _a.clientWidth, scrollLeft = _a.scrollLeft;
                                scrollRef.current.scrollLeft = scrollLeft + clientWidth;
                            }
                        } }))),
            react_1.default.createElement(Chart_styled_1.StyledChartSkipLink, { id: "chart-end", as: TextLink, href: "#chart-start" },
                react_1.default.createElement(Copy, { copyKey: "backToTopOfChart" })),
            react_1.default.createElement("div", { id: "chart-tooltip-portal", "aria-hidden": "true" }))));
};
exports.Chart = Chart;
